/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, Inject } from '@angular/core';
import { MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { MaxRangeSelectionStrategy } from './max-range-strategy';

@Directive({
  selector: '[maxRange]',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy,
    },
  ],
})

/**
 *Directive to inject MaxRange strategies onto datepickers across the application
 */
export class MaxRangeDirective {
  /**
   *Constructor
   * @param {MaxRangeSelectionStrategy<any>} maxRangeStrategy
   */
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private maxRangeStrategy: MaxRangeSelectionStrategy<any>
  ) {}

  /**
   * Input that recieves the max range itself.
   * @param {number} value
   */
  @Input() set maxRange(value: number) {
    this.maxRangeStrategy.deltaInMonths = +value || 24; // Default to 24 months
  }
}
